import {
  setIsLoggedIn,
  setUserDetails,
  setActiveCustomerTab,
} from '@/core/redux/commonSlice';
import { routes } from '@/utils/routes/routes';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from '@/core/redux/store'; // Adjust path based on your project
import { classNames } from 'primereact/utils';
import { postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { toast } from 'react-toastify';
import ChatWindow from './ChatWindow';
import { defaultAvatar } from '@/utils/imagepath';

const CustomerMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeTab = useSelector(
    (state: RootState) => state.common.activeCustomerTab
  );
  const [isChatOpen, setIsChatOpen] = useState(false);
  const user = useSelector((state: RootState) => state.common.userDetails);
  const menuItems = [
    { key: 'orders', label: 'My Orders' },
    { key: 'wishlist', label: 'My Wishlist' },
    { key: 'address', label: 'My Addresses' },
    { key: 'my-referrals', label: 'My Referrals' },
    { key: 'account-details', label: 'Account Details' },
    // { key: 'welcome', label: 'Dashboard Home' },
  ];

  const handleTabChange = (tab: string) => {
    dispatch(setActiveCustomerTab(tab));
  };

  const handleLogout = async () => {
    try {
      const response = await postData(end_points.logout.url);
      if (response.status == 200 || response.status == 201) {
        toast.success(response?.data?.message);
        dispatch(setUserDetails({}));
        dispatch(setIsLoggedIn(false));
        dispatch(setActiveCustomerTab('welcome')); // Optional: reset to default
        localStorage.clear();
        navigate(routes.login);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="ac-user-info">
        <div className="ac-user-info-s">
          <img
            src={user?.image_path || defaultAvatar}
            alt="Customer"
          />
        </div>
        <div className="ac-user-info-e">
            <h2>{user?.name}</h2>
            <div className="ac-user-info-e-btn">
              <button onClick={handleLogout} className='btn btn-so'>
                <i className='ti ti-logout'></i>Logout
              </button>
            </div>
        </div>
      </div>
      <ul>
        {menuItems.map((item) => (
          <li
            key={item.key}
            className={`${activeTab === item.key ? 'active' : ''}`}
            onClick={() => handleTabChange(item.key)}
          ><h6>{item.label}</h6> 
          </li>
        ))}
        <li onClick={() => setIsChatOpen(true)}>
            <h6>Need Help?</h6>  
        </li>        
      </ul>
      <ChatWindow isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </>
  );
};

export default CustomerMenu;
